import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { UserRole } from "../../../@types/userRole";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";
export const findUserRoles = createAsyncThunk(
  "user/findUserRoles",
  async (idUser: number, { rejectWithValue, getState }) => {
    const state = getState() as RootState;

    try {
      const { data } = await axiosInstance.get(`${api.baseURL}userrole`, {
        params: {
          where: {
            user: idUser,
            enabled: true,
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          },
        },
      });
      return data as UserRole[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
